import { Button, Form, Input, Switch, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { getDiscount } from "apis/discount";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";

export const DiscountsTrack: React.FC<IResourceComponentsProps> = () => {
  const { formProps } = useForm<any>({
    resource: "discounts",
    action: "edit",
    redirect: false,
  });

  const [discount, setDiscount] = useState<any>(null);
  //   const [isDiscount, setIsDiscount] = useState<boolean>(false);

  const handleData = useCallback(async () => {
    const data = await getDiscount("tracks");
    setDiscount(data);
  }, []);

  useEffect(() => {
    handleData();
  }, [handleData]);

  //   useEffect(() => {
  //     if (discount) {
  //       if (discount?.isDiscount) {
  //         setIsDiscount(discount?.isDiscount);
  //       }
  //     }
  //   }, [discount]);

  const dataForm = useMemo(() => {
    return {
      ...formProps,
      dataSource: discount,
    };
  }, [discount, formProps]);

  return (
    discount && (
      <Form
        initialValues={{
          remember: true,
        }}
        style={{ marginTop: "40px" }}
        {...dataForm}
        layout="vertical"
      >
        <div className={styles.flex}>
          <div className={styles.w25}>
            <Form.Item
              label="Manual discount"
              name="isDiscount"
              rules={[
                {
                  required: false,
                },
              ]}
              className={styles.block}
            >
              <Switch
                // onChange={(active) => setIsDiscount(active)}
                defaultChecked={discount.isDiscount}
              />
            </Form.Item>
          </div>
        </div>
        {(
          <div>
            <div>
              <Form.Item
                label="Discount override (%)"
                name="discountOverride"
                rules={[
                  {
                    required: true,
                    message: "Discount override is required",
                  },
                ]}
                initialValue={discount?.discountOverride}
                className={styles.block}
              >
                <Input
                  min={0}
                  max={100}
                  type="number"
                  className={styles.input}
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                label="Start date"
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "Start date is required",
                  },
                ]}
                initialValue={discount?.startDate}
                className={styles.block}
              >
                <Input className={styles.input} type="date" />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                label="End date"
                name="endDate"
                rules={[
                  {
                    required: true,
                    message: "End date is required",
                  },
                ]}
                className={styles.block}
                initialValue={discount?.endDate}
              >
                <Input className={styles.input} type="date" />
              </Form.Item>
            </div>
            <div className={styles.w5}>
              <Form.Item name="type" initialValue="tracks"></Form.Item>
            </div>
          </div>
        )}

        <Form.Item className={styles.button} wrapperCol={{ offset: 8 }}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  );
};
